
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/embed/html5-games/[nid]",
      function () {
        return require("private-next-pages/embed/html5-games/[nid]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/embed/html5-games/[nid]"])
      });
    }
  